import { layoutConfigs } from "../layouts/layoutConfig";

export const sortByDate = (array) => {
  array?.sort(function (a, b) {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateB - dateA;
  });
  return array;
};

export const importAll = (r) => {
  return r.keys().map(r);
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const getProjectOptions = () =>
  Object.values(layoutConfigs).map((config) => ({
    title: config.title,
    path: config.path,
    musicStyle: config.musicStyle,
    logos: config.logos,
  }));
